/*$AMPERSAND_VERSION*/
var Collection = require('ampersand-collection');
var lodashMixin = require('ampersand-collection-lodash-mixin');
var restMixins = require('ampersand-collection-rest-mixin');


module.exports = Collection.extend(lodashMixin, restMixins);



//////////////////
// WEBPACK FOOTER
// ./~/ampersand-rest-collection/ampersand-rest-collection.js
// module id = 81
// module chunks = 0